var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGift(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5967 1.38904C8.72302 -0.463014 5.68351 -0.463014 3.80713 1.38904C1.93076 3.2411 1.9335 6.2456 3.80713 8.10037C5.68077 9.95514 12.0012 9.48873 12.0012 9.48873C12.0012 9.48873 12.473 3.24381 10.5967 1.38904ZM5.89474 6.03952C4.01836 4.18475 5.02239 2.58759 5.02239 2.58759C5.02239 2.58759 5.73289 2.49268 7.60927 4.34474C9.4829 6.1968 10.262 8.62643 10.262 8.62643C10.262 8.62643 7.76837 7.89158 5.89474 6.03952Z",
    fill: "#FFB43B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1928 1.38904C18.3191 -0.463014 15.2796 -0.463014 13.4033 1.38904C11.5269 3.2411 11.996 9.48873 11.996 9.48873C11.996 9.48873 18.3164 9.95242 20.1928 8.10037C22.0692 6.24831 22.0692 3.24381 20.1928 1.38904ZM18.1079 6.03952C16.2343 7.89157 13.7763 8.65897 13.7763 8.65897C13.7763 8.65897 14.5198 6.19679 16.3934 4.34474C18.267 2.49268 19.8855 3.48243 19.8855 3.48243C19.8855 3.48243 19.9843 4.18475 18.1079 6.03952Z",
    fill: "#FF823B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.002 13.2855C13.5928 13.2855 14.8824 12.0108 14.8824 10.4383C14.8824 8.86581 13.5928 7.59106 12.002 7.59106C10.4112 7.59106 9.12158 8.86581 9.12158 10.4383C9.12158 12.0108 10.4112 13.2855 12.002 13.2855Z",
    fill: "#FFB43B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.1777 10.4417H17.1426V23.9999H23.1777C23.6303 23.9999 24.0007 23.6338 24.0007 23.1864V11.2551C24.0007 10.8077 23.6303 10.4417 23.1777 10.4417Z",
    fill: "#6D2E66"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0.822972 10.4417C0.370337 10.4417 0 10.8077 0 11.2551V23.1864C0 23.6338 0.370337 23.9999 0.822972 23.9999H17.1453V10.4417H0.822972Z",
    fill: "#913D88"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0007 16.6702H17.1426V19.3827H24.0007V16.6702Z",
    fill: "#FF823B"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6696 10.4417H20.5723V23.9999H21.6696V10.4417Z",
    fill: "#FF823B"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1453 16.6702H0V19.3827H17.1453V16.6702Z",
    fill: "#FFA53B"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M9.39559 10.4417H6.65234V23.9999H9.39559V10.4417Z",
    fill: "#FFB93B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGift);
export default __webpack_public_path__ + "static/media/gift.55bab34fd8bc69df15a5e4f080be5a82.svg";
export { ForwardRef as ReactComponent };